export default {
  title: 'כל המידע נקלט בהצלחה!',
  subTitle: 'המערכת תמשיך כעת את קליטת הקובץ',
};
